import { MembershipProductEvaluationCode } from "~/generated/graphql";

const MINIMUM_TOKEN_SIZE = 1;
const CREDIT_CARD_BIN_PATTERN = /^\d{8}/;
const CREDIT_CARD_DATE_PATTERN = /^20\d{2}-(0[1-9]|1[0-2])$/;

export const convertEvaluationParamToCode = (
  evaluation: string,
): MembershipProductEvaluationCode => {
  switch (evaluation) {
    case "BLOCKING_BIN":
      return MembershipProductEvaluationCode.BlockingBin;
    case "RISKY_CREDIT_CARD":
      return MembershipProductEvaluationCode.RiskyCreditCard;
    case "VOLUNTARY_ABUSER":
      return MembershipProductEvaluationCode.VoluntaryAbuser;
    case "INVOLUNTARY_ABUSER":
      return MembershipProductEvaluationCode.InvoluntaryAbuser;
    case "YEARLY_REJECTED":
      return MembershipProductEvaluationCode.YearlyRejected;
    default:
      return MembershipProductEvaluationCode.NoRisk;
  }
};

export const isValidToken = (
  newToken: string | undefined,
  oldToken: string,
): boolean =>
  !!newToken && newToken.length > MINIMUM_TOKEN_SIZE && newToken !== oldToken;

export const isValidCreditCardBin = (
  newCCBin: string | undefined,
  oldCCBin: string,
): boolean =>
  !!newCCBin && CREDIT_CARD_BIN_PATTERN.test(newCCBin) && newCCBin !== oldCCBin;

export const isValidCreditCardDate = (
  newCCDate: string | undefined,
  oldCCDate: string,
): boolean =>
  !!newCCDate &&
  CREDIT_CARD_DATE_PATTERN.test(newCCDate) &&
  newCCDate !== oldCCDate;

export const formatCCDateFromYearAndMonth = (
  expirationYear: string,
  expirationMonth: string,
): string => `20${expirationYear}-${expirationMonth}`;
